var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 97,
    viewBox: "0 0 175 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0674 83.0404C49.503 82.0926 50.2462 69.4352 50.0189 67.9297L44.6054 67.9653L41.8125 74.8795C40.8287 73.55 40.4485 70.2679 39.6129 68.4019L34.3131 68.5956L33.9999 82.7346L38.8579 82.6877L39.0453 76.5046L40.6505 81.7747L42.383 81.7827L44.4481 75.7034L44.5284 83.333L49.0674 83.0404Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8254 71.5688C84.6813 70.4435 85.8646 75.1644 81.6112 75.2795L81.8254 71.5688ZM86.5865 77.7032C87.7668 76.2849 88.7865 76.1723 88.9963 73.8719C89.6757 66.4256 79.3881 67.2913 77.1031 68.8097L76.9172 82.7672L81.2501 82.7379L81.3751 78.5098L82.7516 78.4647L84.2545 82.6898C85.4007 82.7863 87.9212 82.3422 88.8943 81.8025L86.5862 77.7039L86.5865 77.7032Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.221 68.0171L130.687 68.1484L130.404 82.8807L139.261 82.6764L139.505 78.2273L135.209 78.1349L135.341 76.6411L138.35 76.5593L138.556 73.3814L135.581 73.3349L135.647 72.1784C136.84 71.6852 138.589 71.9808 139.997 71.826L140.221 68.0175V68.0171Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6362 69.761L62.2725 68.8234L61.4658 68.7765L57.1733 69.4031C57.731 71.2757 58.7463 73.6814 59.4895 75.5338C60.5902 78.2775 59.561 80.6337 60.0157 83.4318L64.7273 83.4182C65.1717 81.5038 64.8113 79.4325 65.0566 77.4731C65.1945 76.3753 66.7561 74.7047 67.4183 73.6806L67.8788 72.9004C68.603 72.1392 70.5001 69.868 70.4943 68.9576L65.8303 68.6855L63.3292 72.7995C62.8331 72.0072 62.7099 70.7755 62.6366 69.761H62.6362Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.205 68.1802L95.8936 68.2924L95.883 73.0418L98.8849 72.9688L98.9245 82.6771L103.229 82.4827L104.058 72.6777L107.091 72.589L107.205 68.1802Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.895 68.0293L114.676 68.0751C114.392 70.6994 113.997 79.9632 114.386 82.3392L122.917 81.5787C123.219 80.6419 123.433 78.0646 123.238 77.1157L119.182 76.9899L119.896 68.0293H119.895Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.8394 14H96.0381C96.5342 14 96.8367 14.4059 96.7102 14.902L91.85 33.9511C91.7235 34.4472 91.2139 34.8531 90.7178 34.8531H68.5187C68.0226 34.8531 67.7201 34.4472 67.8469 33.9511L72.7071 14.902C72.8336 14.4059 73.3433 14 73.8394 14Z",
    fill: "url(#paint0_linear_324_292)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9876 21.8994H109.793C110.1 21.8994 110.285 22.1506 110.204 22.4582L107.059 34.2942C106.978 34.6015 106.659 34.853 106.352 34.853H94.5469C94.2392 34.853 94.0544 34.6015 94.1362 34.2942L97.2807 22.4582C97.3625 22.1506 97.6807 21.8994 97.9884 21.8994H97.9876Z",
    fill: "url(#paint1_linear_324_292)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2837 38.8335H79.3943C79.6649 38.8335 79.8299 39.055 79.761 39.3256L77.1096 49.718C77.0403 49.9886 76.7628 50.2101 76.4918 50.2101H64.3812C64.1106 50.2101 63.9456 49.9886 64.0145 49.718L66.6659 39.3256C66.7348 39.055 67.0127 38.8335 67.2837 38.8335Z",
    fill: "url(#paint2_linear_324_292)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2564 38.8335H105.329C105.86 38.8335 106.19 39.268 106.064 39.7989L101.204 60.1878C101.077 60.7187 100.539 61.1532 100.008 61.1532H77.9357C77.4044 61.1532 77.0741 60.7187 77.2006 60.1878L82.0607 39.7989C82.1872 39.268 82.7251 38.8335 83.2564 38.8335Z",
    fill: "url(#paint3_linear_324_292)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_324_292",
    x1: 82.2785,
    y1: 14,
    x2: 82.2785,
    y2: 34.8531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_324_292",
    x1: 102.17,
    y1: 21.8994,
    x2: 102.17,
    y2: 34.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_324_292",
    x1: 72.8908,
    y1: 38.7242,
    x2: 71.1286,
    y2: 47.1106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65983B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_324_292",
    x1: 91.6322,
    y1: 38.8335,
    x2: 91.6322,
    y2: 61.1532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.29af9a56de9d6f632d42e2945a8579a8.svg";
export { ForwardRef as ReactComponent };